'use strict'

export default {
  install (Vue, options) {
    Vue.prototype.$textToHtml = function (text) {
      return text.replace(/&quot;/, '<p>').replace(/＼n/g, '</p><p>').replace(/&quot;/, '</p>')
    }
    Vue.prototype.$text = function (text) {
      return text.replace(/&quot;/, '').replace(/＼n/g, '').replace(/&quot;/, '')
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/fun.js